module.exports = __webpack_public_path__ + "img/6.3417746c.png";